module.exports = __webpack_public_path__ + "static/img/hdw11.3671ccc0.png";